export default __webpack_public_path__ + "static/media/Biomedical Equipment Planning and Procurement.b60ce4ab.png";